export class UxProgress {
    constructor() {
        this.started = false;
        this.startListeners = [];
        this.stopListeners = [];
    }
    start() {
        this.started = true;
        this.triggerStartListeners();
    }
    stop() {
        this.started = false;
        this.triggerStoptListeners();
    }
    onStart(callback) {
        this.startListeners.push(callback);
    }
    onStop(callback) {
        this.stopListeners.push(callback);
    }
    triggerStartListeners() {
        this.startListeners.forEach((listener) => {
            listener();
        });
    }
    triggerStoptListeners() {
        this.stopListeners.forEach((listener) => {
            listener();
        });
    }
}
export default UxProgress;
//# sourceMappingURL=progress.js.map